export const constants = {
     BaseURL: 'http://localhost',
     RedirectURL: 'https://j2wofferletter.com/', 
};